import {Icon} from "@mui/material";
import {IconProps} from "@mui/material/Icon/Icon";
import styles from "./Icon.module.scss";

export default function SolidIcon(props:IconProps) {
    return <Icon {...props} className={props.className ? props.className + " " +styles.Root : styles.Root} />
}